module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.8fb55b7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sourceSansPro/SourceSansPro-Regular.woff
// module id = xUly
// module chunks = 27